import { render, staticRenderFns } from "./Consumos.vue?vue&type=template&id=4288241b&scoped=true"
import script from "./Consumos.vue?vue&type=script&lang=js"
export * from "./Consumos.vue?vue&type=script&lang=js"
import style0 from "./Consumos.vue?vue&type=style&index=0&id=4288241b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4288241b",
  null
  
)

export default component.exports